import React, { ReactElement } from 'react';
import { Stack } from 'rsuite';
import InfoIcon from './InfoIcon';
import { CustomHTML } from './CustomHTML';

interface LabelWithInfoIconProps {
  className?: string;
  infoText?: string;
  label: string;
}

const LabelWithInfoIcon = ({
  className = '',
  infoText,
  label,
}: LabelWithInfoIconProps): ReactElement => {
  return (
    <Stack
      spacing={10}
      className={className}
    >
      <Stack.Item>
        <CustomHTML text={label} />
      </Stack.Item>
      {infoText && (
        <Stack.Item>
          <InfoIcon text={infoText} />
        </Stack.Item>
      )}
    </Stack>
  );
};

export default LabelWithInfoIcon;
